angular.module('tasks').directive('taskActivityFeed', ["PATH", "ADMIN_TIMEZONE", "taskManagementService", "activityTitleService", function (PATH, ADMIN_TIMEZONE, taskManagementService, activityTitleService) {
  return {
    restrict: 'E',
    scope: {
      cardId: '=',
      activities: '=',
      managers: '=',
      cardMembers: '=',
      onRemoveComment: '&',
      onUpdateComment: '&'
    },
    templateUrl: PATH.components + 'taskManagement/activityFeed/view.html',
    link: function ($scope) {
      $scope.removeComment = function (comment) {
        $scope.onRemoveComment({ activityComment: comment });
      };
      $scope.updateComment = function (comment, mentions, oldMentions) {
        $scope.onUpdateComment({ activityComment: comment, mentions: mentions, oldMentions: oldMentions });
      };

      $scope.orderActivityByTime = function (item) {
        return -moment(item.time).unix();
      };

      $scope.formatMessageAccordingToType = function (activity) {
        var message = activityTitleService.format(taskManagementService.adminsList, activity);
        message.push('on');
        // eslint-disable-next-line max-len
        message.push('<span class="time">' + moment.utc(activity.time).tz(ADMIN_TIMEZONE).format('MMMM D hh:mm:ss A') + '</span>');

        return message.join(' ');
      };
    }
  };
}]);



// WEBPACK FOOTER //
// ./~/ng-annotate-loader/loader.js!./project/components/taskManagement/activityFeed/directive.js